import React from 'react'

const PageNotFound = () => {

  return (
    <h1 style={{ textAlign: 'center' }}>404 - page not found</h1>
  )

}

export default PageNotFound